import { where, limit } from 'firebase/firestore';

import Firebase from '@/clients/firebase/firebase-react-query';
import { Book, UserProfile } from 'types';

import { Links } from '~/lib/helpers/link-helper';

import TileRow from './tile-row';
import BookTile from './tiles/book';

interface SellerBooksRowProps {
  seller?: UserProfile;
  sellerBooks?: Book[];
}

export default function SellerBooksRow(props: SellerBooksRowProps) {
  const books = Firebase<Book>().fetchCollectionDocsByQuery('books', [where('seller_id', '==', props.seller?.id), limit(20)], {
    initialData: props.sellerBooks,
    enabled: Boolean(props.seller),
  });

  function renderBookTiles() {
    return books.data?.map((book) => (
      <BookTile
        key={book.id}
        book={book}
        source="book-page"
        cartAddSource="book-page"
        cartStyle='large'
      />
    ));
  }

  return (
    <TileRow
      title={'More from this seller'}
      {...(props.seller && {
        link: { href: Links.bookstore(props.seller).show },
      })}
    >
      {renderBookTiles()}
    </TileRow>
  );
}
